import { render } from "./VTableUint.vue?vue&type=template&id=7dfbbb61&scoped=true"
const script = {}

import "./VTableUint.vue?vue&type=style&index=0&id=7dfbbb61&scoped=true&lang=less"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfbbb61"]])

export default __exports__